/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { array_unique, clip, elementHasClassName, elementHasOneOfClassNames, get_localized_string2, htmlspecialchars, removeClass, removeMultipleClasses0, replaceText, toggleMultipleClasses0 } from './util.js';
import { default_ajax_error_handler } from './fetch-util.js';
import { getFromSession, setInSession } from './session-util.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { startProgress, stopProgress } from './progress-util.js';
import { scrollElementIntoView } from './dialog-util.js';

import { MPlugins } from './plugins.js';
import { MDLocale } from './locale-impl.js';

import { createSearchResultInfo } from './search-result-info.js';
import { queryListMediaIDs } from './index-data.js';
import { MDMedia } from './media-data.js';
import { MDMeta } from './meta-data.js';
import { MDObject } from './object-data.js';
import { MThumbnails } from './thumbnails.js';

import { MVTrees } from './trees.js';
import { MVMediaMetadata } from './media-data-view.js';

import { SelectionClassesObserver } from './media-items-selection-observer.js';


const scheduleUpdate = requestAnimationFrame;


export class RVSource {
	constructor( list_type, object_id ) {
		this.list_type = list_type;
		this.object_id = object_id;
	}
	hasCategories() {
		return false;
	}
	getListType() {
		return this.list_type;
	}
	getObjectId() {
		return this.object_id;
	}
	getTreeId() {
		return null;
	}
	getCategoryId() {
		return null;
	}
	getObjectItem() {
		return null;
	}
	getListDataObject( list_count, category_count ) {
		return {};
	}
	getWrappedSource() {
		return this;
	}
	_queryListItemsFromURL( post_url, offset, count, _list_meta_ids_str_encoded, additional_postdata, on_response, on_after_update ) {
		const postdata = 'offset='+encodeURIComponent(offset)
						+ '&count='+encodeURIComponent(count)
						+ '&meta_ids='+_list_meta_ids_str_encoded
						+ '&with_categories=1'
						+ '&with_relevance=1'
						+ '&with_visibility_status=1'
						+ '&with_thumb_available=1'
						+ additional_postdata;
		$.postJSON2(
			post_url,
			postdata,
			function _queryListItems_response( response ) {
				if( on_response ) {
					on_response(response);
				}
				if( on_after_update ) {
					on_after_update();
				}
			},
			function() { // timeout
				if( on_after_update ) {
					on_after_update();
				}
			},
			function( jqXHR, textStatus, message ) { // error
				default_ajax_error_handler(jqXHR,textStatus,message);
				if( on_after_update ) {
					on_after_update();
				}
			},
			true
		);
	}
	queryListItems( offset, count, _list_meta_ids_str_encoded, on_response, on_after_update ) {
	}
	onAfterCreateSource( go_create_items_fn, thisWidget ) {
		go_create_items_fn();
	}
	queryListMediaIds( callback ) {
	}
}


export class RVSearchSource extends RVSource {
	constructor( list_type, list_id, tree_id, cat_id ) {
		super(list_type,list_id);
		this.tree_id = tree_id;
		this.cat_id = cat_id;
	}
	hasCategories() {
		return this.tree_id!==null && this.cat_id!==null;
	}
	getTreeId() {
		return this.tree_id;
	}
	getCategoryId() {
		return this.cat_id;
	}
	getListDataObject( list_count, category_count ) {
		return createSearchResultInfo( {
			'list_type':		this.getListType(),
			'list_id':			this.getObjectId(),
			'tree_id':			this.tree_id,
			'cat_id':			this.cat_id,
			'list_count':		list_count,
			'category_count':	category_count
		} );
	}
	_queryIndexListItems( offset, count, _list_meta_ids_str_encoded, additional_postdata, on_response, on_after_update ) {
		this._queryListItemsFromURL('json/media/list-get',offset,count,_list_meta_ids_str_encoded,additional_postdata,on_response,on_after_update);
	}
	queryListItems( offset, count, _list_meta_ids_str_encoded, on_response, on_after_update ) {
		const additional_postdata = '&list_id='+encodeURIComponent(this.getObjectId());
		this._queryIndexListItems(offset,count,_list_meta_ids_str_encoded,additional_postdata,on_response,on_after_update);
	}
	queryListMediaIds( callback ) {
		queryListMediaIDs(this.getObjectId(),callback);
	}
}


export class RVObjectItemsWrappedOntoIndexListSource extends RVSearchSource {
	constructor( list_id, wrapped_source ) {
		super('search',list_id,null,null);
		this.wrapped_source = wrapped_source;
	}
	// getObjectId() {
	// 	return this.wrapped_source.object_id;
	// }
	getObjectItem() {
		return this.wrapped_source.object_item;
	}
	getListDataObject( list_count, category_count ) {
		//console.log({ fn:'RVObjectItemsWrappedOntoIndexListSource::getListDataObject', list_count, category_count });
		return this.wrapped_source.getListDataObject(list_count,category_count);
	}
	getWrappedSource() {
		return this.wrapped_source;
	}
}


export class RVObjectItemsSource extends RVSource {
	constructor( list_type, object_id, object_item ) {
		super(list_type,object_item.object_id||object_id);
		this.object_item = object_item;
	}
	getObjectItem() {
		return this.object_item;
	}
	getListDataObject( list_count, category_count ) {
		//console.log({ fn:'RVObjectItemsSource::getListDataObject', list_count, category_count });
		return MDObject.createObjectResultInfo( {
			'list_type':		this.getListType(),
			'list_id':			this.getObjectId(),
			'list_count':		list_count,
			'object_item':		this.object_item
		} );
	}
	_createSortedIndexListFromAllObjectItems( on_created ) {
		//console.log({ fn:'RVObjectItemsSource::_createSortedIndexListFromAllObjectItems', on_created });
		const postdata = 'type='+encodeURIComponent(this.list_type)
						+'&item_key=media_id'
						+'&object_id='+encodeURIComponent(this.object_id)
						+'&view_sort='+encodeURIComponent(getFromSession('view_sort'));
		$.postJSON2( 'json/object/object-items_sorted_list', postdata, function( j ) {
			if( j && j.sorted_list_id ) {
				on_created(j.sorted_list_id,j.result_count);
			}
		} );
	}
	_createSortedIndexListFromSelectedObjectItems( media_ids, on_created ) {
		//console.log({ fn:'RVObjectItemsSource::_createSortedIndexListFromSelectedObjectItems', media_ids, on_created });
		const postdata = 'media_ids='+encodeURIComponent(media_ids.join(','))
						+'&view_sort='+encodeURIComponent(getFromSession('view_sort'));
		$.postJSON2( 'json/object/object-items_sorted_list_2', postdata, function( j ) {
			if( j && j.sorted_list_id ) {
				on_created(j.sorted_list_id,j.result_count);
			}
		} );
	}
	_queryObjectItems( offset, count, _list_meta_ids_str_encoded, additional_postdata, on_response, on_after_update ) {
		this._queryListItemsFromURL('json/object/object-items',offset,count,_list_meta_ids_str_encoded,additional_postdata,on_response,on_after_update);
	}
	queryListItems( offset, count, _list_meta_ids_str_encoded, on_response, on_after_update ) {
		//console.log({ fn:'RVObjectItemsSource::queryListItems', offset, count, _list_meta_ids_str_encoded, on_response, on_after_update });
		const additional_postdata = '&type='+encodeURIComponent(this.list_type)
									+'&item_key=media_id'
									+'&object_id='+encodeURIComponent(this.object_id);
		this._queryObjectItems(offset,count,_list_meta_ids_str_encoded,additional_postdata,on_response,on_after_update);
	}
	onAfterCreateSource( go_create_items_fn, thisWidget ) {
		//console.log({ fn:'RVObjectItemsSource::onAfterCreateSource', go_create_items_fn, thisWidget });
		const self = this;
		this._createSortedIndexListFromAllObjectItems( function( sorted_list_id, result_count ) {
			thisWidget._source = new RVObjectItemsWrappedOntoIndexListSource(sorted_list_id,self);
			thisWidget._list_count = result_count;
			go_create_items_fn();
		});
	}
	queryListMediaIds( callback ) {
		//console.log({ fn:'RVObjectItemsSource::queryListMediaIds', callback });
		MDObject.queryObjectMediaIDs(this.getListType(),null,this.getObjectId(),callback);
	}
}


export class RVFilteredObjectItemsSource extends RVObjectItemsSource {
	constructor( list_type, object_id, object_item, filters, filter_fns ) {
		super(list_type,object_id,object_item);
		this.filters = filters;
		this.filter_fns = filter_fns;
	}
	setFilterFunctions( filter_fns ) {
		this.filter_fns = filter_fns;
	}
	getListDataObject( list_count, category_count ) {
		let list_obj = super.getListDataObject(list_count,category_count);
		list_obj._state.filter = Object.assign({},this.filters);
		return list_obj;
	}
	// queryListItems( offset, count, _list_meta_ids_str_encoded, on_response, on_after_update ) {
	// 	//console.log({ fn:'RVFilteredObjectItemsSource::queryListItems', offset, count, _list_meta_ids_str_encoded, on_response, on_after_update });
	// 	super.queryListItems(offset,count,_list_meta_ids_str_encoded,function( response ) {
	// 		/**
	// 		 * response properties:
	// 		 * --------------------
	// 		 *		media_ids
	// 		 *		r_download
	// 		 *		r_edit
	// 		 *		r_delete
	// 		 *		relevance
	// 		 *		categories
	// 		 *		thumb_available
	// 		 *		visibility_status
	// 		 *		meta
	// 		 */
	// 		//console.log({ fn:'RVFilteredObjectItemsSource::queryListItems -> response', response });
	// 		if( on_response ) on_response(response);
	// 	},on_after_update);
	// }
	onAfterCreateSource( go_create_items_fn, thisWidget ) {
		//console.log({ fn:'RVFilteredObjectItemsSource::onAfterCreateSource', go_create_items_fn, thisWidget });
		const self = this;
		this.queryListMediaIds( function( media_ids, result_count ) {
			// apply filters ...
			for( const flt_name in self.filters ) {
				if( !self.filters.hasOwnProperty(flt_name) ) continue;
				const flt_value = self.filters[flt_name];
				if( flt_value!='' ) {
					const filter_fn = self.filter_fns[flt_name] || null;
					if( filter_fn ) {
						media_ids = filter_fn(media_ids,flt_value);
					}
				}
			}
			// result_count after filters ...
			result_count = media_ids.length;
			self._createSortedIndexListFromSelectedObjectItems( media_ids, function( sorted_list_id, result_count ) {
				thisWidget._source = new RVObjectItemsWrappedOntoIndexListSource(sorted_list_id,self);
				thisWidget._list_count = result_count;
				go_create_items_fn();
			});
		} );
	}
	// queryListMediaIds( callback ) {
	// 	//console.log({ fn:'RVFilteredObjectItemsSource::queryListMediaIds', callback });
	// 	super.queryListMediaIds( function( media_ids, result_count ) {
	// 		//console.log({ fn:'RVFilteredObjectItemsSource::queryListMediaIds -> callback', media_ids, result_count });
	// 		if( callback ) callback(media_ids,result_count);
	// 	} );
	// }
}



// export class RVObjectItemsWithFiltersSource extends RVObjectItemsSource {
// 	constructor( list_type, object_id, object_item ) {
// 		super(list_type,object_id,object_item);
// 	}
//	getListDataObject( list_count, category_count ) {
//		const r = super.getListDataObject(list_count,category_count);
//		r.flt_... = this.flt_;
//	}
// }


export function createRVSource( list_type, list_id, object_item, tree_id, cat_id ) {
	switch( list_type ) {
	case 'search':
	case 'slist':
		return new RVSearchSource(list_type,list_id,tree_id,cat_id);
	}
	return new RVObjectItemsSource(list_type,list_id,object_item);
}




/**
 * Manja Media Result View Widget ( .mjMediaResultViewWidget )
 *
 * methods:
 *  - TODO
 *
 * usage:
 *  $('#container').mjMediaResultViewWidget( { ... } )
 *
 */
(function($,mj) {
	// using the new $.widget utility..
	$.widget( 'mj.mjMediaResultViewWidget', {

		options: {
			dyn_id_pfx: 'mt',
			buttons_dependent: {},
			buttons: [ ],
			get_view_size: function()		{
				return getFromSession('view_size',9);
			},
			set_view_size: function(size)	{
				setInSession('view_size',size);
			},
			get_view_type: function()		{
				return getFromSession('view_type','table');
			},
			set_view_type: function(type)	{
				setInSession('view_type',type);
			},

			max_items_per_page: function( thisWidget ) {
				const vt = thisWidget.options.get_view_type();
				const vs = thisWidget.options.get_view_size();	//  6..32
				const ivs = 33-vs;								// 27.. 1
				let r = 100;
				switch( vt ) {
				case 'table':	r = Math.min(200,Math.max(15, 5*Math.round(0.2*(3+4.1*ivs)) )); break;
				case 'grid':	r = Math.min(300,Math.max(20, 5*Math.round(0.2*(6+4.3*ivs)) )); break;
				case 'list':	r = Math.min(100,Math.max(10, 5*Math.round(0.2*(2+2.1*ivs)) )); break;
				}
				return r;
			},

			mvdetail_open_fn: null,

			/* callbacks:
			  	list_changed( evt, data )
				selection_changed( evt, {...} )
				view_type_changed( evt, {type:type} )
				result_nodes_loaded( evt, {media_ids} )
			*/

			lightbox_enabled: true,
		},

		_create: function() {
			this._source = new RVSearchSource('search',null,null,null);
			this._change_count = 0;	// incremented on structural changes (e.g. items added, loaded, ..)

			this._list_count = null;
			this._category_count = null;

			this._load_all = false;

			this._progressive_load_blocked = false;

			this._update_nodes_callbacks = [];

			this._max_loaded_idx = -1;
			this._max_items_idx = -1;

			this._createMoreItems_blocked = false;
			this._createMoreItems_blocked_on_unblock_calls = [];

			this._has_more_action_node = false;
			this._more_action_node_offset = null;

			this._idle_gather_count = 0;
			this._scroll_gather_count = 0;

			this._media_buttons_html = '';
			this._meta_html = '';

			this._thumbnail_div_html = '<div class="smn thumbnail loading">'+MThumbnails.getPreCreatedThumbLoadAnimHTML()+'</div>';

			this._meta_renderer = {};
			this._tree_renderer = {};

			this._tid_ig = null;
			this._use_ric = false;//!!window.requestIdleCallback;

			this._sco = null;

			this._lightbox_enabled = this.options.lightbox_enabled ?? true;

			this._lightbox_editable = true;

			this._invalidateScrollViewBounds();

			this._setup_thumb_view_status_requests('table');

			const thisWidget = this;

			// NOTE: removed _gather fns from widget and used local for performance reasons!
			function _scroll_gather( force ) {
				const sgcX = ( ++ thisWidget._scroll_gather_count ) % 4;
				if( sgcX===3 ) thisWidget._handleProgressiveResultLoad();
				if( force || thisWidget._scroll_gather_count >= 31 ) {
					thisWidget._scroll_gather_count = 0;
					thisWidget._idle_gather_count = 0;
					if( thisWidget._source.getObjectId() != 0 ) {
						scheduleUpdate( function _scroll_gather__updateVisibleNodes() {
							thisWidget._updateVisibleNodes(1,'_scroll_gather_'+(force?'forced':'notforced'));
						} );
					}
				}
			}

			function _idle_gather() {
				++ thisWidget._idle_gather_count;
				_scroll_gather(thisWidget._idle_gather_count>=12);
				if( thisWidget._use_ric ) thisWidget._tid_ig = window.requestIdleCallback( _idle_gather, { timeout:173 } );
				else thisWidget._tid_ig = window.setTimeout( _idle_gather, 173 );
			}

			// handle some basic events
			this.element.scroll( function( e ) {
				thisWidget._invalidateScrollViewBounds();
				_scroll_gather(false);
				//doesnt bubble anyway..://e.stopPropagation();
			} );

			this._sco = new SelectionClassesObserver(this.element[0],true);

			// start idle gather update processing
			if( this._use_ric ) this._tid_ig = window.requestIdleCallback( _idle_gather, {timeout:750} );
			else this._tid_ig = window.setTimeout( _idle_gather, 750 );

		}, // _create()

		_invalidateScrollViewBounds: function() {
			this._scrollViewBounds = null;
		},

		_getScrollViewBounds: function(update) {
			if(update) this._scrollViewBounds = null;
			if( this._scrollViewBounds===null ) {
				const root0 = this.element[0];
				this._scrollViewBounds = {
					scrollTop: root0.scrollTop,
					clientHeight: root0.clientHeight,
					updated: true,
				};
			} else {
				this._scrollViewBounds.updated = false;
			}
			return this._scrollViewBounds;
		},

		_setup_thumb_view_status_requests: function( view_type ) {
			// list of required meta_ids, prepared for use in http request parameters
			this._list_meta_ids_str_encoded = encodeURIComponent( array_unique( [...mj.required_thumbnail_meta_ids,...mj.result[view_type].meta_ids] ).join(',') );

			// create optimized call to functions of MediaThumbnailView plugins
			const mtv_plugins_arr = MPlugins.getByType('MediaThumbnailView');
			const mtv_plugins_arr_len = mtv_plugins_arr.length;

			this._update_thumbnail_view_by_plugins = function( node0, media_id, meta ) {
				const node = $(node0);
				for( let i=0; i<mtv_plugins_arr_len; ++i ) mtv_plugins_arr[i].updateViewNode('result',node,media_id,meta);
			};
			this._query_thumbnails_view_status_by_plugins = function( media_ids, meta ) {
				// console.log(['_query_thumbnails_view_status_by_plugins',media_ids,meta]);
				for( let i=0; i<mtv_plugins_arr_len; ++i ) mtv_plugins_arr[i].queryMediaViewStatus('result',media_ids,meta,false);
			};
			this._query_thumbnails_view_status_by_plugins1 = function( media_id, mmeta ) {
				// console.log(['_query_thumbnails_view_status_by_plugins1',media_id,mmeta]);
				let xmeta = {};
				xmeta[media_id] = mmeta;
				for( let i=0; i<mtv_plugins_arr_len; ++i ) mtv_plugins_arr[i].queryMediaViewStatus('result',[media_id],xmeta,false);
			};
		},

		_cancelAllUpdateCallbacks: function( done_cb ) {
			const thisWidget = this;
			this._update_nodes_callbacks = [];
			scheduleUpdate( function() {
				thisWidget._update_nodes_callbacks = [];
				done_cb();
			} );
		},

		_destroy: function() {
			const thisWidget = this;
			// cancel task queues
			this._cancelAllUpdateCallbacks( function() {
				// remove observer
				if( thisWidget._sco ) {
					thisWidget._sco.disconnect();
					thisWidget._sco = null;
				}
				// stop all active timeouts
				if( thisWidget._tid_ig!==null ) {
					if( thisWidget._use_ric ) window.cancelIdleCallback(thisWidget._tid_ig);
					else window.clearTimeout(thisWidget._tid_ig);
				}
				// remove any children
				thisWidget._empty(false);
			} );
		},

		getSource: function() {
			return this._source;
		},

		getWrappedSource: function() {
			const wrappedSource = this._source.getWrappedSource();
			return wrappedSource;
		},

		getListType: function() {
			return this._source.getListType();
		},

		getWrappedListType: function() {
			const wrappedSource = this._source.getWrappedSource();
			const wrappedListType = wrappedSource.getListType();
			return wrappedListType;
		},

		getObjectId: function() {
			return this._source.getObjectId();
		},

		getListId: function() {
			return this._source.getObjectId();
		},

		loadSource: function( source, object_item, load_all, done_cb ) {
			this._change_count ++;

			// console.log({w:'loadSource',source,object_item,load_all});

			const thisWidget = this;
			this._cancelAllUpdateCallbacks( function() {
				// const rebuild_buttons = thisWidget._source.getListType() != source.getListType();
				const rebuild_buttons = thisWidget.getWrappedListType() !== source.getListType();

				thisWidget._source = source;

				thisWidget._list_count = object_item ? ( object_item.list_count || object_item.count || 0 ) : 0;
				thisWidget._category_count = 0;

				if( load_all!==null ) thisWidget._load_all = load_all;
				thisWidget._empty(true);
				thisWidget._max_loaded_idx = -1;
				thisWidget._max_items_idx = -1;
				thisWidget.setViewSize( thisWidget.options.get_view_size(), false );

				if( rebuild_buttons ) {
					const viewtype = thisWidget.options.get_view_type();
					thisWidget._buildMediaButtonsHtml(viewtype);
				}

				if( thisWidget._source.hasCategories() ) thisWidget._createCategoryItems();
				thisWidget.element.scrollTop(0);
				thisWidget._change_count ++;
				thisWidget._invalidateScrollViewBounds();

				thisWidget.element.removeAttr('data-xext');

				const wrappedSource = thisWidget._source.getWrappedSource();
				MPlugins.callOnAllPluginsOfType('MediaResultView','beforeUpdateResult',true,thisWidget.element,wrappedSource.getListType(),wrappedSource.getObjectId(),wrappedSource.getObjectItem());
				thisWidget._change_count ++;


				thisWidget.element.attr('data-viewtype',thisWidget.options.get_view_type());
				thisWidget.element.attr('data-listtype',wrappedSource.getListType());


				thisWidget.selectionChanged(null,false);

				thisWidget._source.onAfterCreateSource(
					function _go_create_items_fn() {
						const count_per_page = thisWidget._load_all ? thisWidget._list_count : thisWidget._getMaxItemsPerPage();
						thisWidget._createMoreItems( 0, count_per_page, function( cmi_success ) {
							thisWidget.listChanged();
							if( done_cb ) done_cb();
						} );
					},
					thisWidget
				);
			} );
		},

		loadSearchResult: function( object_id, tree_id, cat_id, list_count, load_all, done_cb ) {
			const object_item = { list_count: list_count };
			const source = new RVSearchSource('search',object_id,tree_id,cat_id);
			return this.loadSource(source,object_item,load_all,done_cb);
		},

		loadSearchList: function( object_id, list_count, load_all, done_cb ) {
			const object_item = { list_count: list_count };
			const source = new RVSearchSource('slist',object_id,null,null);
			return this.loadSource(source,object_item,load_all,done_cb);
		},

		loadObject: function( list_type, object_id, object_item, load_all, done_cb ) {
			const source = new RVObjectItemsSource(list_type,object_id,object_item);
			return this.loadSource(source,object_item,load_all,done_cb);
		},

		loadEmpty: function( list_type, done_cb ) {
			let source;
			if( list_type==='search' || list_type==='slist' ) {
				source = new RVSearchSource(list_type,0,null,null);
			} else {
				source = new RVObjectItemsSource(list_type,0,{list_count:0});
			}
			return this.loadSource(source,null,false,done_cb);
		},

		_getMaxItemsPerPage: function() {
			const mipp = this.options.max_items_per_page;
			return typeof mipp === 'function' ? mipp(this) : mipp;
		},

		_createCategoryItems: function() {
			const tree_id = this._source.getTreeId();
			const cat_id = this._source.getCategoryId();
			if( !mj.trees.hasOwnProperty(tree_id) ) return;

			const all_nodes = mj.trees[tree_id].nodes;
			const all_nodes_order = mj.trees[tree_id].nodes_order;
			const ano_len = all_nodes_order.length;
			const view_type = this.options.get_view_type();
			let html = '';
			let ctidx = 0;
			this._category_count = 0;
			if( mj.category_parents.hasOwnProperty(cat_id) && mj.category_parents[cat_id]!=0 ) {
				// add item for linking to parent category (up in hierarchy)
				const node_id = mj.category_parents[cat_id];
				const node = all_nodes[node_id];
				const title_attr = htmlspecialchars(mjt('media-category-lbl-back','!').replace('%1',node.name),true,true)+' (ID: '+node_id+')';
				const back_lbl = mjt('media-category-lbl-back','!').replace('%1',htmlspecialchars(node.name));
				if( view_type==='table' || view_type==='grid' ) {
					html += '<div class="item category up" mj_tree_id="'+tree_id+'" mj_cat_id="'+node_id+'">';
					html += '<div mj_ctidx="'+ctidx+'" class="smn cthumbnail link" title="'+title_attr+'"></div>';
					html += '<div class="cmu">';
					html += '<div class="category_title1" title="'+title_attr+'"><span class="category_title">'+back_lbl+'</span></div>';
					html += '</div>';
					html += '</div>';
				} else if( view_type==='list' ) {
					html += '<div class="item category up" mj_tree_id="'+tree_id+'" mj_cat_id="'+node_id+'">';
					html += '<div mj_ctidx="'+ctidx+'" class="smn cthumbnail link" title="'+title_attr+'"></div>';
					html += '<div class="cmu"><div class="category_menu"></div></div>';
					html += '<div class="meta_container">';
					html += '<table class="media_meta" cellpadding="0" cellspacing="0">';
					html += '<tr class="m-head"><th colspan="2"><span class="category_title1 link" title="'+title_attr+'">'+back_lbl+'</span></th></tr>';
					html += '</table>';
					html += '</div>';
					html += '</div>';
				}
				ctidx ++;
			}
			if( cat_id > 0 ) {
				// get child nodes of cat_id and add them to view
				for( let i=0; i<ano_len; ++i ) {
					const node_id = all_nodes_order[i];
					const node = all_nodes[node_id];
					if( node.parent == cat_id ) {
						const title_attr = htmlspecialchars(node.name,true,true)+' (ID: '+node_id+')';
						if( view_type==='table' || view_type==='grid'  ) {
							html += '<div class="item category" mj_tree_id="'+tree_id+'" mj_cat_id="'+node_id+'">';
							html += '<div mj_ctidx="'+ctidx+'" class="smn cthumbnail link" title="'+title_attr+'"></div>';
							html += '<div class="cmu">';
							html += '<div class="category_title1" title="'+title_attr+'"><span class="category_title">'+htmlspecialchars(node.name)+'</span></div>';
							html += '</div>';
							html += '</div>';
						} else if( view_type==='list' ) {
							html += '<div class="item category" mj_tree_id="'+tree_id+'" mj_cat_id="'+node_id+'">';
							html += '<div mj_ctidx="'+ctidx+'" class="smn cthumbnail link" title="'+htmlspecialchars(node.name,true,true)+'"></div>';
							html += '<div class="cmu"><div class="category_menu"></div></div>';
							html += '<div class="meta_container">';
							html += '<table class="media_meta" cellpadding="0" cellspacing="0">';
							html += '<tr class="m-head"><th>'+mjt('media-category-lbl-name')+':</th><td><span class="category_title1 link" title="'+title_attr+'">'+htmlspecialchars(node.name)+'</span></td></tr>';
							html += '<tr class="m-odd"><th>'+mjt('media-category-lbl-id')+':</th><td>'+node_id+'</td></tr>';
							html += '<tr class="m-even"><th>'+mjt('media-category-lbl-created')+':</th><td><span class="avoid-wrap-line">'+htmlspecialchars(node.crd_by)+',</span> <span class="avoid-wrap-line">'+MDLocale.fmt_datetime(node.crd_dt)+'</span></td></tr>';
							html += '<tr class="m-odd"><th>'+mjt('media-category-lbl-modified')+':</th><td><span class="avoid-wrap-line">'+htmlspecialchars(node.mod_by)+',</span> <span class="avoid-wrap-line">'+MDLocale.fmt_datetime(node.mod_dt)+'</span></td></tr>';
							html += '</table>';
							html += '</div>';
							html += '</div>';
						}
						ctidx ++;
						this._category_count ++;
					}
				}
				if( this._category_count===0 && this._list_count===0 ) {
					if( this._source.hasCategories() && mj.category_parents.hasOwnProperty(cat_id) && mj.category_parents[cat_id]!=0 ) {
						// here we will show an 'up' category node, instead of 'no-result'
						this.element.removeClass('no-result');
					} else {
						this.element.addClass('no-result');
					}
				} else {
					this.element.removeClass('no-result');
				}
				this._change_count ++;
			}
			if( ctidx>0 ) {
				// insert pseudo items (for alignment issues of items in last row of flex layout)
				for( let i=0; i<30; ++i ) html += '<div class="item pseudo pseudo-category"></div>';
				// insert a separator between categories and media assets
				html += '<div class="separator"></div>';
			}
			this.element.append(html);
			this._change_count ++;
			this._loadCategoryNodesThumbnails();
		},

		_loadCategoryNodesThumbnails: function() {
			const cnodes = this.element.children('.category');
			const cnodes_len = cnodes.length;
			if( cnodes_len ) {
				const thumbs = cnodes.children('.cthumbnail');
				const sidx = elementHasClassName(cnodes[0],'up') ? 1 : 0;
				if( sidx==1 ) {
					// 'up' node has special thumbnail
					MVTrees.createCategoryUpThumbnail(thumbs[0],this._cthumbs_w,this._cthumbs_h);
				}
				for( let i=sidx; i<cnodes_len; ++i ) {
					const cnode = cnodes.eq(i);
					MVTrees.createCategoryThumbnail(cnode.attr('mj_tree_id'),cnode.attr('mj_cat_id'),thumbs[i],this._cthumbs_w,this._cthumbs_h);
				}
				this._change_count ++;
			}
		},

		_createMoreItems: function( offset, count_per_page, done_cb ) {
			const thisWidget = this;
			this._cancelAllUpdateCallbacks( function() {
				thisWidget._doCreateMoreItems(offset,count_per_page,done_cb);
			} );
		},

		_unblockCreateMoreItems: function() {
			const thisWidget = this;
			thisWidget._createMoreItems_blocked = false;
			// run thisWidget unblock calls that were queued meanwhile ...
			while( thisWidget._createMoreItems_blocked_on_unblock_calls.length ) {
				let cbs = thisWidget._createMoreItems_blocked_on_unblock_calls;
				thisWidget._createMoreItems_blocked_on_unblock_calls = [];
				while( cbs.length > 0 ) {
					const cb = cbs.shift();
					if( cb ) cb();
				}
			}
		},

		_doCreateMoreItems: function( offset, count_per_page, done_cb ) {
			const thisWidget = this;
			if( this._createMoreItems_blocked ) {
				// queue up this task ...
				thisWidget._createMoreItems_blocked_on_unblock_calls.push( function() {
					thisWidget._doCreateMoreItems(offset,count_per_page,done_cb);
				} );
				return;
			}
			this._createMoreItems_blocked = true;
			const next_offset = offset+count_per_page;
			const max_idx = ( this._list_count > next_offset ? next_offset : this._list_count ) - 1;
			let html = '';
			const view_type = this.options.get_view_type();
			const slice_size = 2000;
			$('#'+this.options.dyn_id_pfx+'-terminator,#'+this.options.dyn_id_pfx+'-more-actions,.pseudo-media',this.element).remove();
			thisWidget._change_count ++;
			thisWidget._has_more_action_node = false;
			for( let i=offset; i<=max_idx; ++i ) {
				if( view_type==='list' ) {
					html += '<div id="'+this.options.dyn_id_pfx+'-idx-'+i+'" class="item media new undel" data-mj_mid="0" mj_tidx="'+i+'">'
								+this._thumbnail_div_html
								+'<div class="mmu">'
									+'<div class="media_menu">'+this._media_buttons_html+'</div>'
								+'</div>'
								+'<div class="meta_container"></div>'
							+'</div>';
				} else {
					html += '<div id="'+this.options.dyn_id_pfx+'-idx-'+i+'" class="item media new undel" data-mj_mid="0" mj_tidx="'+i+'">'
								+this._thumbnail_div_html
								+'<div class="mmu">'
									+'<div class="media_menu">'+this._media_buttons_html+'</div>'
									+'<div class="media_id1"><span class="media_id">&nbsp;</span></div>'
								+'</div>'
								+'<div class="meta_container">'+this._meta_html+'</div>'
							+'</div>';
				}
				if( i>offset && i<max_idx-20 && ( (i-offset) % slice_size )===0 ) {
					this.element.append(html);
					const sub_offset = i+1;
					scheduleUpdate( function _doCreateMoreItems_chunk() {
						thisWidget._createMoreItems_blocked_on_unblock_calls.push( function() {
							thisWidget._doCreateMoreItems(sub_offset,count_per_page-(sub_offset-offset),done_cb);
						} );
						thisWidget._unblockCreateMoreItems();
					} );
					return;
				}
			}
			if( max_idx > this._max_items_idx ) this._max_items_idx = max_idx;
			// insert pseudo items (for alignment issues of items in last row of flex layout)
			for( let i=0; i<30; ++i ) html += '<div class="item pseudo pseudo-media"></div>';
			// insert a terminator after media assets
			html += '<div id="'+this.options.dyn_id_pfx+'-terminator" class="terminator"></div>';
			this.element.append(html);
			thisWidget._change_count ++;
			scheduleUpdate( function _doCreateMoreItems_delayed_setup_more_actions() {
				let remaining_count, new_count_per_page, next_count_per_page, more_actions, more_text, more_text_details;
				if( thisWidget._list_count > next_offset ) {
					remaining_count = thisWidget._list_count - next_offset;
					new_count_per_page = thisWidget._getMaxItemsPerPage();
					next_count_per_page = Math.min(new_count_per_page,remaining_count);
					more_text = mjt('more-search-results')
						.replace('%1',next_count_per_page)
						.replace('%2',thisWidget._list_count)
						.replace('%3',next_offset+1)
						.replace('%4',next_offset+1+next_count_per_page);
					if( next_count_per_page===1 ) more_text = mjt('more-search-results-1').replace('%1',thisWidget._list_count);
					more_text_details = mjt('more-search-results-details','!')
						.replace('%1',next_count_per_page)
						.replace('%2',thisWidget._list_count)
						.replace('%3',next_offset+1)
						.replace('%4',next_offset+1+next_count_per_page);
					more_actions = $('<div id="'+thisWidget.options.dyn_id_pfx+'-more-actions" class="more-actions"><div class="more" title="'+htmlspecialchars(more_text_details,true,true)+'">'+more_text+'</div></div>');
					more_actions.find('.more')
						.click( function _doCreateMoreItems_more_clicked(e,evt_done_cb) {
							thisWidget._doCreateMoreItems(next_offset,next_count_per_page,evt_done_cb);
						} );
					if( remaining_count>next_count_per_page ) {
						$('<div class="remaining">'+mjt('remaining-search-results').replace('%1',remaining_count).replace('%2',thisWidget._list_count)+'</div>')
							.click( function _doCreateMoreItems_remaining_clicked(e,done_cb) {
								startProgress(true);
								window.setTimeout( function() {
									thisWidget._doCreateMoreItems( next_offset, remaining_count, function(success) {
										if( done_cb ) done_cb(success);
										stopProgress();
									} );
								}, 4 );
							} )
							.appendTo(more_actions);
					}
					more_actions.appendTo(thisWidget.element);
					thisWidget._has_more_action_node = true;
					thisWidget._more_action_node_offset = null;
					thisWidget._change_count ++;
				}
				thisWidget._unblockCreateMoreItems();
				// trigger visible nodes update
				if( done_cb ) done_cb(true);
				thisWidget._updateVisibleNodes(4,'_doCreateMoreItems('+offset+','+count_per_page+')');
			} );
		},

		_prepareMetadataRenderer: function( view_type ) {
			const nmc = $(document.createElement('div')).append(get_localized_string2(mj.result[view_type].html,mj.locale));
			const mdn = nmc.find('[meta_id]');
			const mdn_len = mdn.length;
			const tin = nmc.find('[tree_id]');
			const tin_len = tin.length;
			this._meta_renderer = {};
			for( let i=0; i<mdn_len; ++i ) {
				const mdn_elem = mdn[i];
				let meta_id_attr = mdn_elem.getAttribute('meta_id');
				if( meta_id_attr ) {
					// parse meta_id_attr into ..
					// - either: meta_id & render_type ("1", "3:plain", "101:list", ...)
					// - or: meta_name & render_type ("filename", "bits-per-pixel:plain", "rights-instructions:list", ...)
					let render_type = 'plain';
					let meta_id = meta_id_attr;
					const p = meta_id_attr.indexOf(':');
					if( p > 0 ) {
						render_type = meta_id_attr.substr(p+1);
						meta_id = meta_id_attr.substr(0,p);
					}
					let metaDef;
					if( !isNaN(meta_id) ) {
						// is numeric => meta_id
						metaDef = MDMeta.getDefinition(meta_id);
					} else {
						// non-numeric => meta_def name
						// lookup meta_id ...
						metaDef = MDMeta.getDefinitionByName(meta_id);
						if( metaDef==null ) meta_id = 0; // invalid or unknown
						else meta_id = metaDef.id;
					}
					if( !this._meta_renderer.hasOwnProperty(meta_id) ) this._meta_renderer[meta_id] = {};
					this._meta_renderer[meta_id][render_type] = MDMeta.getDisplayDataRenderer(meta_id,metaDef);
					$(mdn_elem).addClass( MVMediaMetadata.getMetaDataHolderClassList(meta_id,render_type==='list') );
				}
			}
			this._tree_renderer = {};
			for( let i=0; i<tin_len; ++i ) {
				const tin_elem = tin[i];
				let tree_id_attr = tin_elem.getAttribute('tree_id');
				if( tree_id_attr ) {
					// parse tree_id_attr into tree_id & render_type ("1:path", "1:name" etc..)
					let render_type = 'name';
					let tree_id = tree_id_attr;
					const p = tree_id_attr.indexOf(':');
					if( p > 0 ) {
						render_type = tree_id_attr.substr(p+1);
						tree_id = tree_id_attr.substr(0,p);
					}
					if( !this._tree_renderer.hasOwnProperty(tree_id) ) this._tree_renderer[tree_id] = {};
					this._tree_renderer[tree_id][render_type] = MVTrees.getDisplayDataRenderer(tree_id,render_type);
					$(tin_elem).addClass( MVMediaMetadata.getTreeDataHolderClassList(tree_id,render_type) );
				}
			}
			this._meta_html = nmc.html();
		},

		_setItemMetadata: function( node0, media_id, meta, nmc0 ) {
			const mr = this._meta_renderer;
			// set metadata values
			if( !nmc0 ) return;
			for( const meta_id in mr ) {
				if( !mr.hasOwnProperty(meta_id) ) continue;
				const mrt = mr[meta_id];
				const data = meta[meta_id]||[];
				for( const render_type in mrt ) {
					if( !mrt.hasOwnProperty(render_type) ) continue;
					const nodes = nmc0.getElementsByClassName('meta-id-'+meta_id+(render_type==='plain'?'':'-'+render_type));
					if( !nodes.length ) continue;
					const nodes_len = nodes.length;
					if( data.length===0 ) {
						for( let i=0; i<nodes_len; ++i ) {
							const cn = nodes[i];
							cn.title = '';
							while( cn.lastChild ) cn.lastChild.remove();	//cn.removeChild(cn.lastChild);
						}
					} else {
						const renderer = mrt[render_type];
						const has_complex_html = renderer.hasComplexHTMLDisplay();
						const plain = renderer.getDisplayData(data,true);
						if( has_complex_html || plain.indexOf('\n')!==-1 ) {
							const html = has_complex_html ? renderer.getDisplayData(data,false) : htmlspecialchars(plain);
							for( let i=0; i<nodes_len; ++i ) {
								const cn = nodes[i];
								cn.innerHTML = html;
								cn.title = plain;
							}
						} else if( render_type==='list' ) {
							let html = '';
							for( let di=0; di<data.length; ++di ) {
								const item_plain = renderer.getDisplayDataItem(data[di],true);
								const item_attr_html = htmlspecialchars(item_plain,true,true);
								html += '<span class="data" data-item="'+item_attr_html+'" title="'+item_attr_html+'">'+htmlspecialchars(item_plain)+'</span>';
							}
							for( let i=0; i<nodes_len; ++i ) {
								const cn = nodes[i];
								cn.innerHTML = html;
							}
						} else {
							for( let i=0; i<nodes_len; ++i ) {
								const cn = nodes[i];
								cn.textContent = plain;
								cn.title = plain;
							}
						}
					}
				}
			}
			// update further view status through plugins
			this._update_thumbnail_view_by_plugins(node0,media_id,meta);
		},

		_resetItemCategoriesTreeRendererCache: function() {
			const tr = this._tree_renderer;
			for( const tree_id in tr ) {
				if( !tr.hasOwnProperty(tree_id) ) continue;
				const trt = tr[tree_id];
				for( const render_type in trt ) {
					if( !trt.hasOwnProperty(render_type) ) continue;
					trt[render_type].resetCache();
				}
			}
		},

		_setItemCategories: function( categories, nmc0 ) {
			if( !nmc0 ) return;
			const tr = this._tree_renderer;
			for( const tree_id in tr ) {
				if( !tr.hasOwnProperty(tree_id) ) continue;
				const trt = tr[tree_id];
				const data = categories[tree_id]||[];
				for( const render_type in trt ) {
					if( !trt.hasOwnProperty(render_type) ) continue;
					const nodes = nmc0.getElementsByClassName('tree-id-'+tree_id+'-'+render_type);
					if( nodes.length===0 ) continue;
					if( data.length===0 ) {
						for( let i=0; i<nodes.length; ++i ) {
							const node = nodes[i];
							while( node.firstChild ) node.firstChild.remove();	//node.removeChild(node.firstChild);
							node.title = '';
						}
					} else {
						const renderer = trt[render_type];
						const tmp = renderer.getCachedDisplayData(data);
						const title = tmp[0].join(', ');
						const html = tmp[1].join(', ');
						for( let i=0; i<nodes.length; ++i ) {
							const node = nodes[i];
							node.innerHTML = html;
							node.title = title;
						}
					}
				}
			}
		},

		_handleProgressiveResultLoad: function() {
			if( this._progressive_load_blocked || this._createMoreItems_blocked || this._update_nodes_callbacks.length ) {
				return;
			}
			const thisWidget = this;
			thisWidget._progressive_load_blocked = true;
			const remain_blocked = thisWidget._doHandleProgressiveResultLoad( function _handleProgressiveResultLoad_done_cb(success) {
				thisWidget._progressive_load_blocked = false;
			} );
			if( remain_blocked ) {
				// defered -> remain blocked -> will unblock in callback
			} else {
				// done -> unblock ...
				thisWidget._progressive_load_blocked = false;
			}
		},

		_doHandleProgressiveResultLoad: function( done_cb ) {
			if( !this._has_more_action_node ) return; // fast path - without any DOM access!!

			// load more, when 'more-actions' element is 1.8*0.999 pages below viewport

			const root_bounds = this._getScrollViewBounds();
			const clip_y_btm = root_bounds.scrollTop + root_bounds.clientHeight + Math.round(1.8*0.999*root_bounds.clientHeight);
			if( root_bounds.updated ) this._more_action_node_offset = null;

			if( this._more_action_node_offset===null ) {
				const more_actions_node0 = document.getElementById(this.options.dyn_id_pfx+'-more-actions');
				if( more_actions_node0===null ) return false; // => unblock immediately
				this._more_action_node_offset = more_actions_node0.offsetTop;
			}
			if( this._more_action_node_offset >= clip_y_btm ) return false; // => unblock immediately

			const thisWidget = this;
			scheduleUpdate( function _doHandleProgressiveResultLoad_1() {
				if( thisWidget._createMoreItems_blocked || !thisWidget._has_more_action_node ) {
					if( done_cb ) done_cb(false);
					return;
				}
				// WARNING: must get nodes again (they may have been removed and re-added meanwhile...)
				let my_more_actions_node0, my_more_node;
				if( (my_more_actions_node0=document.getElementById(thisWidget.options.dyn_id_pfx+'-more-actions'))===null || (my_more_node=$('div.more',my_more_actions_node0)).length===0 ) {
					if( done_cb ) done_cb(false);
					return;
				}
				my_more_node.triggerHandler('click',function(success) {
					if( done_cb ) done_cb(success);
				});
			} );
			// => remain blocked
			return true;
		},

		_getNodesMinMaxIndexes: function( candidate_nodes ) {
			// assumed, candidate_nodes are provided in dom order...
			const cnl = candidate_nodes.length;
			if( !cnl ) return [-1,-1];
			return [ parseInt(candidate_nodes[0].getAttribute('mj_tidx'),10), parseInt(candidate_nodes[cnl-1].getAttribute('mj_tidx'),10) ];
		},

		_getUnloadedNodesMinMaxIndexes: function( candidate_nodes ) {
			const cnl = candidate_nodes.length;
			for( let i=0; i<cnl; ++i ) {
				const cn0 = candidate_nodes[i];
				if( elementHasOneOfClassNames(cn0,['new','reload']) ) {
					// found first candidate node ...
					for( let j=cnl-1; j>=i; --j ) {
						const cnx0 = candidate_nodes[j];
						if( elementHasOneOfClassNames(cnx0,['new','reload']) ) {
							// found other candidate node ...
							return [parseInt(cn0.getAttribute('mj_tidx'),10),parseInt(cnx0.getAttribute('mj_tidx'),10)];
						}
					}
					return [-1,-1];
				}
			}
			return [-1,-1];
		},

		_runUpdateNodesCallbacks: function() {
			while( this._update_nodes_callbacks.length ) {
				let cbs = this._update_nodes_callbacks;
				this._update_nodes_callbacks = [];
				while( cbs.length ) {
					const cb = cbs.shift();
					if( cb ) cb();
				}
			}
		},

		_getRunUpdateNodesCallbacksFn: function() {
			const thisWidget = this;
			return function _runUpdateNodesCallbacksFn() {
				return thisWidget._runUpdateNodesCallbacks();
			};
		},

		_updateVisibleNodes: function( skip_treshold, caller_info ) {
			const thisWidget = this;
			if( this._update_nodes_callbacks.length ) {
				if( this._update_nodes_callbacks.length <= skip_treshold ) {
					this._update_nodes_callbacks.push( function _defered_updateVisibleNodes() {
						thisWidget._updateVisibleNodes(skip_treshold,caller_info+' (defered)');
					} );
				}
			} else {
				this._update_nodes_callbacks.push(null); // = block updates
				const on_after_update = this._getRunUpdateNodesCallbacksFn();
				if( !this._doUpdateVisibleNodes(on_after_update) ) scheduleUpdate(on_after_update);
			}
		},

		_doUpdateVisibleNodes: function( on_after_update ) {
			// fast path: skip if all nodes were already updated
			if( this._max_loaded_idx>=0 && this._max_items_idx>=0 && this._max_loaded_idx==this._max_items_idx ) return false; // => unblock immediately

			// determine visible nodes
			const candidate_media_nodes = $('.media',this.element);
			const mnodes = this._max_loaded_idx===-1 ? candidate_media_nodes.filter('.new,.reload') : candidate_media_nodes.slice(this._max_loaded_idx+1).filter('.new,.reload');
			const mnl = mnodes.length;
			if( mnl===0 ) return false; // => unblock immediately

			// determine visibility and prepare to load nodes thumbnails

			const node_height_guess = Math.max( 2*this._thumbs_h, 160 );
			const root_bounds = this._getScrollViewBounds();
			const clip_y_top = root_bounds.scrollTop - Math.max(140,Math.round(0.2*root_bounds.clientHeight)) - node_height_guess - 1;				// preload 0.2 pages above viewport (or at least 140px above viewports top)
			const clip_y_btm = root_bounds.scrollTop + root_bounds.clientHeight + Math.round(1.5*root_bounds.clientHeight) + 2*node_height_guess;		// preload 1.5 pages below viewport

			const cfg_max_nodes_per_batch = 101;
			const id2idx_str_offs = this.options.dyn_id_pfx.length+5;
			let idx_min = -1;
			let idx_max = -1;
			let last_visible_idx = -1;
			let idx = -1;
			let n = 0;
			for( let i=0; i<mnl; ++i ) {
				const mn = mnodes[i];
				const y = mn.offsetTop;
				if( y < clip_y_top ) continue;
				if( y > clip_y_btm ) break;											// stop scanning elements (further elements have even larger 'top')
				idx = parseInt(mn.id.substr(id2idx_str_offs),10);
				if( last_visible_idx!==-1 && idx-last_visible_idx>1 ) break;		// stop if index is not contiguous (already loaded media should not be re-loaded)
				last_visible_idx = idx;
				if( idx_min===-1 ) idx_min = idx;
				if( ++n >= cfg_max_nodes_per_batch ) break;							// do not update more than x nodes in one batch
			}
			if( idx > idx_max ) idx_max = idx;
			if( idx_min===-1 || idx_max===-1 ) return false; // => unblock immediately

			// get media_ids and meta-data for visible range
			let count = idx_max-idx_min+1;
			if( count===0 ) return false; // => unblock immediately
			if( count > cfg_max_nodes_per_batch ) {
				// should not be possible anymore... but anyway...
				count = cfg_max_nodes_per_batch;
				idx_max = count + idx_min - 1;
			}

			if( this._max_loaded_idx==-1 ) {
				// => what does this case mean actually ???
			} else if( idx_min <= this._max_loaded_idx+1 ) {
				// --------------------------------------------------------------------------------------------------
				// scan through the following nodes, to find the real _max_loaded_idx ...
				// -> in cases where current batch has gaps in list, that were closed by this update step..
				//  * = already loaded
				//  x = loaded in this update step,
				//  . = still unloaded
				//      0123456789
				// 1.  |***xx***..|
				//		here, max_loaded_idx will become 7 (not just 4)
				// 2.  |***xx..***|
				// 		here, max_loaded_idx will become 4
				// --------------------------------------------------------------------------------------------------
				let new_max_loaded_idx = idx_max;
				candidate_media_nodes.slice(idx_max+1).each( function( idx ) {
					if( elementHasOneOfClassNames(this,['new','reload']) ) return false; // stop scan
					new_max_loaded_idx ++;
				} );
				this._max_loaded_idx = new_max_loaded_idx;
			}
			const thisWidget = this;
			scheduleUpdate( function() {
				thisWidget._doUpdateNodes(idx_min,count,on_after_update);
			} );
			// => remain blocked
			return true;
		},

		_doUpdateNodesMinMaxIdx: function( idx_min_max, nprepend, nappend, on_after_update ) {
			if( idx_min_max[0]!==-1 && idx_min_max[1]!==-1 ) {
				let offset = idx_min_max[0];
				let count = idx_min_max[1]-idx_min_max[0] + 1;
				nprepend = Math.min(nprepend,offset);
				nappend = nappend||0;
				offset -= nprepend;
				count += nprepend+nappend;
				this._doUpdateNodes(offset,count,on_after_update);
			} else if( on_after_update ) {
				// artifically defer callback for consistency ...
				scheduleUpdate(on_after_update);
			}
		},

		_doUpdateNodes: function( offset, count, on_after_update ) {
			const thisWidget = this;
			const slice_size = 200;
			if( count > slice_size ) {
				//console.log(['_doUpdateNodes -> _doUpdateNodes() time='+Date.now()]);
				thisWidget._doUpdateNodes(offset,slice_size,function() {
					thisWidget._doUpdateNodes(offset+slice_size,count-slice_size,on_after_update);
				});
				return;
			}

			const on_response = function _doUpdateNodes_on_response( response ) {
				// NOTE: response.media_ids MAY NOT ALWAYS BE an array,
				//       if it is an object, then its keys are the 'absolute' positions in result list!
				const media_ids = response.media_ids;
				const view_type = thisWidget.options.get_view_type();

				const jr_down = response.r_download || {};
				const jr_edit = response.r_edit || {};
				const jr_del = response.r_delete || {};
				const j_relevance = response.relevance || {};
				const j_categories = response.categories || {};
				const j_thumb_available = response.thumb_available || {};
				const j_visibility_status = response.visibility_status || {};

				// start query for further view status infos through plugins
				const media_ids_arr = Object.keys(media_ids).map( function(k) {
					return media_ids[k];
				} );
				thisWidget._query_thumbnails_view_status_by_plugins(media_ids_arr,response.meta);

				thisWidget._resetItemCategoriesTreeRendererCache();

				// build DOM for items ...
				for( const idx in media_ids ) {
					if( !media_ids.hasOwnProperty(idx) ) continue;

					const node0 = document.getElementById(thisWidget.options.dyn_id_pfx+'-idx-'+idx);
					if( node0===null ) continue;

					const media_id = media_ids[idx];
					let meta;
					if( media_id
						&& (
							// response.meta.hasOwnProperty(media_id)
							// &&
							(
								(meta=(response.meta[media_id]||{'-1':[0]})) && meta[-1]
							)
							||
							( jr_down[media_id]!=undefined )
							||
							( jr_edit[media_id]!=undefined )
						)
					) {

						// item is deleted, but is still part of an object / lightbox  ...
						const is_deleted = !response.meta.hasOwnProperty(media_id);

						const relevance_val = j_relevance[idx] || 1;
						const rdwn = !!jr_down[media_id];
						const visibility_status = j_visibility_status[media_id] || 'world';

						// save data on node
						$.data(
							node0,
							{
								media_id: media_id,
								relevance: relevance_val,
								visibility_status: visibility_status,
								r_dwn: rdwn,
								r_edt: !!jr_edit[media_id],
								r_del: !!jr_del[media_id],
							}
						);

						// element "data" attributes 'data-mj_mid', ...
						node0.dataset.mj_mid = media_id;
						node0.dataset.mj_relevance = relevance_val;
						node0.dataset.mj_visibility_status = visibility_status;

						// the classes used on nodes: media new reload done undel + some more :( (expired, advised-of-expiry, incepted, ...)
						toggleMultipleClasses0(
							node0,
							{
								'new': false,
								'reload': false,
								'done': true,
								'undel': !is_deleted,
								'vs-world': visibility_status=='world',
								'vs-private': visibility_status=='private',
								'vs-specific': visibility_status=='specific',
							}
						);

						let node_thumbnail0 = node0.getElementsByClassName('thumbnail')[0];
						removeClass(node_thumbnail0,'loading');
						MThumbnails.createOnTarget(
							node_thumbnail0,
							{
								media_id,
								width: thisWidget._thumbs_w,
								height: thisWidget._thumbs_h,
								thumb_available: !!j_thumb_available[media_id],
								meta,
								thumb_loader_anim: 'precreated',
							}
						);

						// media_menu: show/hide buttons
						if( is_deleted ) {
							// .. keep "mm-lbout" button!
							const dwn_btn = node0.getElementsByClassName('mm-down');
							if( dwn_btn.length && dwn_btn[0].nodeName.toLowerCase()==='div' ) dwn_btn[0].style.display = 'none';
							const open_btn = node0.getElementsByClassName('mm-open');
							if( open_btn.length && open_btn[0].nodeName.toLowerCase()==='div' ) open_btn[0].style.display = 'none';
						} else {
							if( !rdwn ) {
								const dwn_btn = node0.getElementsByClassName('mm-down');
								if( dwn_btn.length && dwn_btn[0].nodeName.toLowerCase()==='div' ) dwn_btn[0].style.display = 'none';
							}
						}

						let nmc0 = node0.getElementsByClassName('meta_container');
						nmc0 = nmc0.length ? nmc0[0] : null;

						// apply meta data template
						if( view_type==='list' && nmc0!==null ) nmc0.innerHTML = thisWidget._meta_html;

						// set display tooltip & media_id
						node_thumbnail0.title = media_id+': '+(meta[101]?meta[101][0]:'');
						const node_media_id = node0.getElementsByClassName('media_id');
						if( node_media_id.length ) replaceText(node_media_id,media_id);	// could contain multiple elements with class="media_id"

						// set display meta data
						thisWidget._setItemMetadata(node0,media_id,meta,nmc0);

						// set display categories
						thisWidget._setItemCategories(j_categories[media_id]||{},nmc0);

					} else {
						// deleted item
						removeMultipleClasses0(
							node0,
							[
								'new',
								'reload',
								'undel',
								'vs-world',
								'vs-private',
								'vs-specific',
							]
						);
						$(node0)
							.find('.media_id').text(mjt('deleted-media-id','!')).end()
							.find('.meta_container').html(thisWidget._meta_html).end()
							.find('.media-overlay-1,.media-overlay-2,.mmu>.media_menu>.mmb').remove().end()
							.find('.thumbnail').attr('title',mjt('deleted-media-id','!')).removeClass('loading');
					}
				}
				thisWidget._trigger( 'result_nodes_loaded', null, { media_ids:media_ids_arr } );
				thisWidget._updateButtonsViewState();
				thisWidget._change_count ++;
				MDMedia.addToMediaPreviewAvailabilityCache(j_thumb_available);
			};

			this._source.queryListItems(offset,count,this._list_meta_ids_str_encoded,on_response,on_after_update);
		},

		_reload: function( load_all, done_cb ) {
			if( load_all!==null ) this._load_all = !!load_all;
			if( this._source.getObjectId() ) {
				const object_item = Object.assign(
					{},
					this._source.getObjectItem(),
					{
						list_count: this._list_count
					}
				);
				this.loadSource(this._source,object_item,this._load_all,done_cb);
			}
		},

		_empty: function( init_status ) {
			this.element.empty().removeClass('no-search no-result');
			this._change_count ++;
			if( init_status ) {
				if( this._source.getListType()==='search' && this._source.getObjectId()==0 ) {
					this.element.addClass('no-search').html('<span id="mr-no-search"></span>');
				}
				if( this._category_count===0 && this._list_count===0 ) {
					let cat_id;
					if( this._source.hasCategories() && (cat_id=this._source.getCategoryId())!==null && mj.category_parents.hasOwnProperty(cat_id) && mj.category_parents[cat_id]!=0 ) {
						// here we will show an 'up' category node, instead of 'no-result'
					} else {
						this.element.addClass('no-result');
					}
				}
			}
		},

		loadRemainingResult: function( on_after_update ) {
			let max_idx = this._max_items_idx;
			if( max_idx==-1 ) {
				const check_nodes = this.element.children('.media.undel').last();
				const idx_min_max = this._getNodesMinMaxIndexes(check_nodes);
				max_idx = idx_min_max[1];
				if( max_idx > this._max_items_idx ) this._max_items_idx = max_idx;
			}
			let cmi_called = false;
			if( max_idx != -1 ) {
				const next_offset = max_idx+1;
				if( this._list_count > next_offset ) {
					cmi_called = true;
					this._createMoreItems(next_offset,this._list_count-next_offset,function(cmi_success) {
						if( on_after_update ) on_after_update();
					} );
				}
			}
			if( !cmi_called && on_after_update ) on_after_update();
		},

		getListCount: function() {
			return this._list_count;
		},

		setItemMetadata: function( node, media_id, meta ) {
			// start requests for further view status infos through plugins
			this._query_thumbnails_view_status_by_plugins1(media_id,meta);
			// set meta data on item
			const node0 = node[0];
			const nmc = node0.getElementsByClassName('meta_container');
			this._setItemMetadata(node0,media_id,meta,nmc.length?nmc[0]:null);
		},

		setItemCategories: function( node, media_id, categories ) {
			this._resetItemCategoriesTreeRendererCache();
			const nmc = node[0].getElementsByClassName('meta_container');
			this._setItemCategories(categories,nmc.length?nmc[0]:null);
		},

		updateSelectedNodes: function( nprepend, nappend, on_after_update ) {
			const thisWidget = this;
			if( this._update_nodes_callbacks.length ) {
				this._update_nodes_callbacks.push( function _defered_updateSelectedNodes() {
					thisWidget.updateSelectedNodes(nprepend,nappend,on_after_update);
				} );
			} else {
				const on_after_update1 = function() {
					if( on_after_update ) on_after_update();
					thisWidget._runUpdateNodesCallbacks();
				};
				this._update_nodes_callbacks.push( null ); // = block updates
				const candidate_nodes = this.element.find('> .media > div.ui-selected.thumbnail').closest('.media').filter('.undel');
				const idx_min_max = this._getUnloadedNodesMinMaxIndexes(candidate_nodes);
				this._doUpdateNodesMinMaxIdx(idx_min_max,nprepend,nappend,on_after_update1);
			}
		},

		restoreDeletedNode: function( node, on_after_update ) {
			const thisWidget = this;
			if( this._update_nodes_callbacks.length ) {
				this._update_nodes_callbacks.push( function _defered_restoreDeletedNode() {
					thisWidget.restoreDeletedNode(node,on_after_update);
				} );
			} else {
				const on_after_update1 = function() {
					if( on_after_update ) on_after_update();
					thisWidget._runUpdateNodesCallbacks();
				};
				this._update_nodes_callbacks.push( null ); // = block updates

				const candidate_nodes = node.find('> div.thumbnail').closest('.media');//.filter('.undel');
				if( candidate_nodes.length ) {
					toggleMultipleClasses0(
						candidate_nodes[0],
						{
							'new': false,
							'reload': true,
							'done': false,
							'undel': true,
							'vs-world': false,
							'vs-private': false,
							'vs-specific': false,
						}
					);
					$.data(candidate_nodes[0],'ctxm_bound',false);

					const idx_min_max = this._getUnloadedNodesMinMaxIndexes(candidate_nodes);
					this._doUpdateNodesMinMaxIdx(idx_min_max,0,0,on_after_update1);
				}
			}
		},


		updateAllNodes: function( on_after_update ) {
			const thisWidget = this;
			if( this._update_nodes_callbacks.length ) {
				this._update_nodes_callbacks.push( function _defered_updateAllNodes() {
					thisWidget.updateAllNodes(on_after_update);
				} );
			} else {
				const on_after_update1 = function() {
					if( on_after_update ) on_after_update();
					thisWidget._runUpdateNodesCallbacks();
				};
				this._update_nodes_callbacks.push( null ); // = block updates
				const candidate_nodes = $('.media.undel',this.element);
				const idx_min_max = this._getUnloadedNodesMinMaxIndexes(candidate_nodes);
				this._doUpdateNodesMinMaxIdx( idx_min_max, 0, 0, on_after_update1 );
			}
		},

		setViewSize: function( size, stopped ) {
			const w = Math.round( 14.2 * size );
			const root0 = this.element[0];
			const rs = '#'+root0.id;
			const vt = this.options.get_view_type();

			const view_cfg_opts = mj.result[vt].opts || {};
			const compact_category_layout = view_cfg_opts.hasOwnProperty('compact_category_layout') ? view_cfg_opts.compact_category_layout : false;
			const category_item_height_factor = view_cfg_opts.hasOwnProperty('category_item_height_factor') ? clip(view_cfg_opts.category_item_height_factor,0.2,1.0) : 0.7;	//( vt==='list' ? 0.7 : 0.7 ),	//0.618,
			const category_item_min_height_factor = category_item_height_factor < 0.5 ? category_item_height_factor : 0.5;
			const category_titles_height_varying = view_cfg_opts.hasOwnProperty('category_titles_height_varying') ? view_cfg_opts.category_titles_height_varying : false;
			const category_titles_lines = view_cfg_opts.hasOwnProperty('category_titles_lines') ? parseInt(view_cfg_opts.category_titles_lines,10) : 1;//2;

			// resize thumbnails & show/hide menu and set css depending on size
			const lwfix = 2;
			const lhfix = 2;
			let css = '';
			let h, ch;
			switch( vt ) {
			case 'table':
			case 'grid':
				h = ch = w;
				if( size < 8 ) {
					// small layout - thumbnail only
					css += rs+'.view-table > .item { width:'+w+'px; height:'+h+'px; margin:1px 1px; }\n';
					css += rs+'.view-table div.thumbnail { height:'+(h-lhfix)+'px; }\n';
					css += rs+'.view-table div.cthumbnail { height:'+(ch-lhfix)+'px; }\n';
					// scale down overlays..
					css += rs+'.view-table > .item > .media-overlay-2 { background-size:75%; opacity:0.75; }\n';
					if( vt==='grid' ) {
						css += rs+'.view-table.view-grid > .item { margin:0px 0px; min-width:'+(22)+'px; max-width:'+(w)+'px; width:auto; height:auto; }\n';
						css += rs+'.view-table.view-grid div.thumbnail { width:auto; min-height:'+(h-lhfix-20)+'px; max-height:'+(h-lhfix)+'px; }\n';
						css += rs+'.view-table.view-grid div.cthumbnail { width:auto; min-height:'+(ch-lhfix-20)+'px; max-height:'+(ch-lhfix)+'px; }\n';
					}
					css += rs+'.view-table .media_meta, ';
					css += rs+'.view-table .mmu, ';
					css += rs+'.view-table .cmu { display:none; }\n';
				} else {
					// big layout - with menu and media_id

					// fix height ..
					if( vt==='table' ) {
						// .. more quadratic
						h = ch = Math.round( 12.0 * size );
					} else if( vt==='grid' ) { //&& compact_category_layout===false ) {
						// .. more quadratic
						h = ch = Math.round( 12.0 * size );
					}

					if( vt==='grid' ) {
						css += rs+'.view-table.view-grid > .item { margin:0px 0px; min-width:'+(28)+'px; max-width:'+Math.round(1.3*(w)+2)+'px; width:auto; height:auto; }\n';
						css += rs+'.view-table.view-grid > .item.category { margin:0px 2px 2px 0px; width:'+(w)+'px; }\n';
						css += rs+'.view-table.view-grid div.thumbnail { width:auto; min-height:'+(h-66)+'px; max-height:'+(h)+'px; height:'+(h)+'px; }\n';
						if( compact_category_layout ) {
							// category_item_height_factor*height for category thumbnails height
							css += rs+'.view-table.view-grid div.cthumbnail { width:auto; min-height:'+Math.round(category_item_min_height_factor*(ch-66))+'px; max-height:'+Math.round(category_item_height_factor*(ch-lhfix))+'px; height:'+Math.round(category_item_height_factor*(ch-lhfix))+'px; }\n';
						} else {
							// full height for category thumbnails height
							css += rs+'.view-table.view-grid div.cthumbnail { width:auto; min-height:'+Math.round(0.5*(ch-66))+'px; max-height:'+(ch-lhfix)+'px; height:'+(ch-lhfix)+'px; }\n';
						}
						css += rs+'.view-table .media_meta, ';
						css += rs+'.view-table .mmu { display:none; }\n';
						css += rs+'.view-table .cmu { display:block; }\n';
					} else if( compact_category_layout ) {
						// category_item_height_factor*height for category thumbnails height
						css += rs+'.view-table > .item { width:'+w+'px; height:auto; margin:2px 2px; }\n';
						css += rs+'.view-table div.thumbnail { height:'+(h-lhfix)+'px; }\n';
						css += rs+'.view-table div.cthumbnail { min-height:'+Math.round(category_item_min_height_factor*(ch-66))+'px; height:'+Math.round(category_item_height_factor*(ch-lhfix))+'px; }\n';
					} else {
						css += rs+'.view-table > .item { width:'+w+'px; height:auto; margin:2px 2px; }\n';
						css += rs+'.view-table div.thumbnail { height:'+(h-lhfix)+'px; }\n';
						css += rs+'.view-table div.cthumbnail { height:'+(ch-lhfix)+'px; }\n';
					}

					// compute title line height..
					let elem1 = this.element.children('div.item.category').first();
					let ct1lh = '11px';
					if( elem1.length ) {
						ct1lh = elem1.find('.category_title1').css('line-height');
					} else {
						elem1 = $('<div class="item category"><div class="cmu"><div class="category_title1"><span class="category_title">M</span></div></div></div>')
							.appendTo(this.element);
						ct1lh = elem1.find('.category_title1').css('line-height');
						elem1.remove();
					}

					const category_titles_line_height = clip(parseFloat(ct1lh),5,55) || 11;
					let category_titles_height = Math.round( 1 + category_titles_lines * category_titles_line_height );

					category_titles_height = clip(category_titles_height,12,77);
					if( category_titles_height_varying ) {
						css += rs+'.view-table .category_title1 { max-height:'+(category_titles_height)+'px; white-space:normal; }\n';
					} else {
						css += rs+'.view-table .category_title1 { height:'+(category_titles_height)+'px; max-height:'+(category_titles_height)+'px; white-space:'+(category_titles_height>category_titles_line_height+2?'normal':'nowrap')+'; }\n';
					}
				}
				break;
			case 'list':
				h = ch = w;
				if( compact_category_layout ) ch = Math.round( 12.0 * size );
				css += rs+'.view-list > .item { height:auto; min-width:'+(w+320)+'px; flex:1 0 '+(w+320)+'px; min-height:'+(h)+'px; }\n';
				css += rs+'.view-list > .item.category { min-height:'+Math.round(category_item_height_factor*(ch-2*lhfix)+2)+'px; }\n';
				css += rs+'.view-list div.thumbnail { width:'+(w-2)+'px; min-height:'+(h-2*lhfix)+'px; line-height:'+(h-2*lhfix)+'px; }\n';
				css += rs+'.view-list div.cthumbnail { width:'+(w-2)+'px; min-height:'+Math.round(category_item_height_factor*(ch-2*lhfix)+0)+'px; line-height:'+Math.round(category_item_height_factor*(ch-2*lhfix))+'px; }\n';
				css += rs+'.view-list .item::before { width:'+Math.round(1.2*w-2+10)+'px; }\n';
				break;
			}

			this._thumbs_w = w - lwfix;
			this._thumbs_h = h - lhfix;

			this._cthumbs_w = w - lwfix;
			if( size < 8 ) {
				this._cthumbs_h = ch - lhfix;
			} else if( vt==='list' ) {
				if( compact_category_layout ) this._cthumbs_h = Math.round(category_item_height_factor*(ch-2*lhfix))-lhfix;
				else this._cthumbs_h = ch-lhfix;
			} else if( compact_category_layout ) {
				this._cthumbs_h = Math.round(category_item_height_factor*(ch-lhfix))-lhfix;
			} else {
				this._cthumbs_h = ch-lhfix;
			}

			this._change_count ++;

			this._invalidateScrollViewBounds();

			this._setup_thumb_view_status_requests(vt);

			if( stopped ) {
				startProgress(true);
				const thisWidget = this;
				scheduleUpdate( function() {
					thisWidget._max_loaded_idx = -1;
					thisWidget._max_items_idx = -1;
					const media_nodes = $('.media',thisWidget.element);
					const clear_nodes = media_nodes.filter('.undel').addClass('reload');								// force image re-loading
					window.setTimeout( function() {
						// remove thumbnail images
						const clear_nodes_thumbnails = clear_nodes.find('.thumbnail');
						clear_nodes_thumbnails.each( function() {
							MThumbnails.destroyOnTarget(this);
						} );
						window.setTimeout( function() {
							$('#mj-dynamic-styles-'+thisWidget.options.dyn_id_pfx).replaceWith( '<style type="text/css" id="mj-dynamic-styles-'+thisWidget.options.dyn_id_pfx+'">\n'+css+'</style>' );
							clear_nodes_thumbnails.addClass('loading');	// set loading state
							window.setTimeout( function() {
								// update states and nodes
								thisWidget.options.set_view_size(size);
								// update visible result items
								thisWidget._change_count ++;
								stopProgress();
								scheduleUpdate( function() {
									if( thisWidget._source.hasCategories() ) thisWidget._loadCategoryNodesThumbnails();
									if( thisWidget._source.getObjectId()!=0 ) thisWidget._updateVisibleNodes(8,'setViewSize');
									thisWidget._change_count ++;
								} );
							}, 4 );
						}, 4 );
					}, 4 );
				} );
			} else {
				$('#mj-dynamic-styles-'+this.options.dyn_id_pfx).replaceWith( '<style type="text/css" id="mj-dynamic-styles-'+this.options.dyn_id_pfx+'">\n'+css+'</style>' );
				// delay the idle update..
				this._idle_gather_count = 0;
				this._scroll_gather_count = 0;
			}
		},

		setViewType: function( type, save, done_cb ) {
			this._empty(true);
			if( save ) this.options.set_view_type(type);
			// create buttons to be added to thumbnails
			this._buildMediaButtonsHtml(type);
			this._prepareMetadataRenderer(type);
			// set classes
			const css_classes_for_type = type==='list' ? 'view-list' : ( type==='table' ? 'view-table' : 'view-table view-grid' );
			this.element.removeClass('view-list view-table view-grid').addClass(css_classes_for_type);
			this._change_count ++;
			// recreate view
			this._reload(this._load_all,done_cb);
			// update button states
			this._trigger('view_type_changed',null,{'type':type});
		},

		actionOnWholeResult: function( callback ) {
			if( this._list_count!==0 ) {
				this._source.queryListMediaIds(callback);
			}
		},

		openWholeResultInDetailView: function( done_cb, mode ) {
			const mvdetail_open_fn = this.options.mvdetail_open_fn;
			if( mvdetail_open_fn ) {
				this.actionOnWholeResult( function(media_ids) {
					mvdetail_open_fn( media_ids, mode||null, -1, null, function() {
						if( done_cb ) done_cb();
					} );
				} );
			}
		},


		listChanged: function() {
			//console.trace({ fn:'mjMediaResultViewWidget::listChanged' });
			const data = this._source.getListDataObject(this._list_count,this._category_count);
			this._trigger( 'list_changed', null, data );
		},

		selectionChanged: function( evt, calledFrom ) {
			//console.log({ fn:'mjMediaResultViewWidget::selectionChanged', evt, prepare_context_toolbar });
			const thisWidget = this;
			this._trigger(
				'selection_changed',
				evt,
				{
					'opt_open_whole_list_cb':		this._list_count > 1
														? (done_cb,mode) => thisWidget.openWholeResultInDetailView(done_cb,mode)
														: null,
					'list_type':					this._source.getListType(),
					'object_id':					this._source.getObjectId(),
					'object_item':					this._source.getObjectItem(),
					'calledFrom':					calledFrom,
				}
			);
		},

		getVisibleResultsCount: function() {
			return this.element.children('.media').length;
		},
		getVisibleNodeByMediaId: function( media_id ) {
			const node = this.element.children('.media[data-mj_mid='+media_id+'].undel');
			return node.length ? node : null;
		},
		getVisibleNodeByTreeIdAndCatId: function( tree_id, cat_id ) {
			const node = this.element.children('.category[mj_tree_id='+tree_id+'][mj_cat_id='+cat_id+']');
			return node.length ? node : null;
		},

		selectVisibleNodes: function( media_ids, replace_selection, scroll_into_view ) {
			const candidate_nodes = $('> .media.undel',this.element);
			if( replace_selection ) {
				candidate_nodes.find('.ui-selected').removeClass('ui-selected');
				$('> .category .ui-selected',this.element).removeClass('ui-selected');
			}
			let selected_nodes = [];
			for( let i=0; i<media_ids.length; ++i ) {
				const media_id = media_ids[i];
				selected_nodes.push( candidate_nodes.filter('[data-mj_mid='+media_id+']').find('> .thumbnail').addClass('ui-selected') );
			}
			if( scroll_into_view && selected_nodes.length ) {
				scrollElementIntoView( selected_nodes[0].closest('.media'), this.element, 0, 3 );
			}
			this.selectionChanged(null,true);
		},

		selectVisibleCategoryNode: function( tree_id, cat_id, scroll_into_view ) {
			$('> .category .ui-selected',this.element).removeClass('ui-selected');
			$('> .media .ui-selected',this.element).removeClass('ui-selected');
			const cat_node = this.getVisibleNodeByTreeIdAndCatId(tree_id,cat_id);
			if( cat_node ) {
				let selected_nodes = [];
				selected_nodes.push( cat_node.find('> .cthumbnail').addClass('ui-selected') );
				if( scroll_into_view && selected_nodes.length ) {
					scrollElementIntoView( selected_nodes[0].closest('.category'), this.element, 0, 3 );
				}
				this.selectionChanged(null,true);
			}
		},

		getThumbW: function() {
			return this._thumbs_w;
		},
		getThumbH: function() {
			return this._thumbs_h;
		},
		getCThumbW: function() {
			return this._cthumbs_w;
		},
		getCThumbH: function() {
			return this._cthumbs_h;
		},

		_getItemDimensions: function( $elem, node0_height ) {
			const p = $elem.offset();
			let pos = {
				top:	Math.floor(p.top+1.5),
				left:	Math.floor(p.left+1.5),
			};
			pos.bottom = pos.top  + node0_height       - 4;
			pos.right  = pos.left + $elem.outerWidth() - 4;
			return pos;
		},

		collectSelectableItems: function( mode, boundaries ) {
			const media = this.element.children('.media.undel');
			const mlen = media.length;
			if( mlen===0 ) return [];

			const nodes = media.get();
			const node0_height = nodes[0].clientHeight;

			const root_bounds = this._getScrollViewBounds(mode==='prepare');
			const clip_y_top  = root_bounds.scrollTop - node0_height;
			const clip_y_btm  = root_bounds.scrollTop + root_bounds.clientHeight + node0_height;

			if( mode==='prepare' ) {
				boundaries.top = clip_y_top;
				boundaries.btm = clip_y_btm;
			} else { // scrolling
				boundaries.top = Math.min(clip_y_top,boundaries.top);
				boundaries.btm = Math.max(clip_y_btm,boundaries.btm);
			}

			let selectees = [];
			for( let i=0; i<mlen; ++i ) {
				const nd = nodes[i];
				const y = nd.offsetTop;
				if( y > boundaries.btm ) {
					// reached the bottom - done
					break;
				} else if( y >= boundaries.top ) {
					const selectee = $(nd).find('.smn');
					// pre-compute dimensions
					$.data(selectee[0],'selectable-dimensions',this._getItemDimensions(selectee,node0_height));
					// and add node to result
					selectees.push(selectee[0]);
				}
			}
			return selectees;
		},

		_buildMediaButtonsHtml: function( viewtype ) {
			let buttons = [];
			const wrappedListType = this.getWrappedListType();
			if( this.options.buttons_dependent.hasOwnProperty(wrappedListType) ) {
				buttons = this.options.buttons_dependent[wrappedListType].slice();
			}
			buttons = [...buttons,...this.options.buttons];
			if( viewtype==='table' || viewtype==='grid' ) buttons.reverse();
			this._media_buttons_html = buttons.join('');
		},

		_updateButtonsViewState: function() {
			const wrappedListType = this.getWrappedListType();
			const $lb_btns = this.element.find( wrappedListType==='lightbox' ? '.mm-lbout' : '.mm-lbin' );
			$lb_btns.toggle(this._lightbox_enabled);
			$lb_btns.toggleClass('disabled',!this._lightbox_editable);
		},

		setLightboxEditable: function( lb_editable ) {
			if( this._lightbox_editable !== lb_editable ) {
				this._lightbox_editable = lb_editable;
				this._updateButtonsViewState();
			}
		},

		getChangeCount: function() {
			return this._change_count;
		}

	});	// $.widget( 'mj.mjMediaResultViewWidget', ...

})(jQuery,mj);
